import { render } from "./BaseSelect.vue?vue&type=template&id=5a15e810&scoped=true"
import script from "./BaseSelect.vue?vue&type=script&lang=js"
export * from "./BaseSelect.vue?vue&type=script&lang=js"

import "./BaseSelect.vue?vue&type=style&index=0&id=5a15e810&scoped=true&lang=css"
import "./BaseSelect.vue?vue&type=style&index=1&id=5a15e810&lang=css"
script.render = render
script.__scopeId = "data-v-5a15e810"

export default script